export default {
  name: "lightBox",
  namespaced: true,

  state: {
    image: null,
  },

  getters: {},

  actions: {},

  mutations: {
    show(state, image) {
      state.image = image;
      console.log("show", state.image);
    },
  },
};
